import { InputSize, Select } from "shared/components";
import { ApplicantType } from "shared/types";
import { roles } from "shared/constants/roles";
import { useMemo } from "react";
import { TemplateVerificationsSettings } from "types/landlord/verificationTemplate";

interface Props {
  value: ApplicantType;
  onChange: (role: ApplicantType) => void;
  isDisabled: boolean;
  disabledRoles?: ApplicantType[];
  className?: string;
  templateVerificationsSettings?: TemplateVerificationsSettings;
  size?: InputSize;
}

export const RoleSelect = ({
  value,
  onChange,
  isDisabled,
  className,
  templateVerificationsSettings,
  disabledRoles: _disabledRoles = [],
  size = InputSize.BASE
}: Props) => {
  const disabledRoles = useMemo(() => {
    return Object.keys(templateVerificationsSettings || {}).filter(
      (key) =>
        templateVerificationsSettings?.[key]?.enabled_screening_services ===
        false
    );
  }, [templateVerificationsSettings]);

  const updatedRoles = useMemo(
    () =>
      roles.map((role) => {
        const disabledRole =
          _disabledRoles.includes(role.value) ||
          disabledRoles.includes(role.value);
        return {
          ...role,
          isDisabled: disabledRole,
          tooltip: disabledRole ? "This role is not available." : undefined
        };
      }),
    [disabledRoles, _disabledRoles]
  );

  return (
    <div>
      <Select
        size={size}
        className={className}
        id="role"
        options={updatedRoles}
        menuPortalTarget={document.body}
        placeholder="Select role"
        isDisabled={isDisabled}
        value={value}
        onChange={(e) => onChange(e.target.value as ApplicantType)}
      />
    </div>
  );
};
